import { mediaItems } from '@/mocks/home';

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            视频专区
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            深度解析视频内容，用影像还原娱乐圈的真实面貌
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden transition-all duration-300 hover:border-primary-200 cursor-pointer"
            >
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-white/90 group-hover:bg-primary-500 group-hover:text-white transition-colors">
                    <i className="ri-play-fill text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/70 text-white text-xs">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <div className="mt-3 flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line text-sm"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}